import React, { useState, useEffect } from "react";
import "./CreateDevis.css";
import {FilePdf, FileDoc, ArrowUUpLeft, PencilSimple, Trash } from "@phosphor-icons/react";

function DevisPreview({ devis, onClose, onGeneratePDF, onGenerateWord, onEdit, onDelete }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Fermer le menu si on clique à l'extérieur
  useEffect(() => {
    const handleClickOutside = () => setIsMenuOpen(false);
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  if (!devis) return null;

  // Debug pour voir les données reçues
  console.log("DevisPreview - données reçues:", devis);
  console.log("DevisPreview - elements:", devis.elements);

  // Helper pour afficher les éléments hiérarchiques (inspiré de CreateDevis)
  const renderSectionContent = (element) => {
    console.log("Rendu élément:", element);
    
    if (!element || !element.data) {
      return null;
    }
    
    // Fonction helper pour détecter le type de section parent (comme dans CreateDevis)
    const getSectionType = (element) => {
      if (element.type === 'section') {
        return element.data.description;
      }
      if (element.parentSection) {
        return element.parentSection.description;
      }
      return '';
    };

    const sectionType = getSectionType(element);
    
    // Style pour "Contrôle Qualité - HSE" (comme dans CreateDevis)
    if (sectionType.includes('Contrôle Qualité') || sectionType.includes('HSE') || sectionType.includes('Qualité')) {
      return (
        <div key={element.id || Math.random()} className="section-element quality-hse">
          {element.type === 'section' && (
            <div className="section-item">
              <h4>{element.data.description}</h4>
              {element.remarque && (
                <div className="remarque-section-red">
                  <strong>Remarque:</strong> {element.remarque}
                </div>
              )}
            </div>
          )}
          
          {element.type === 'sousSection' && (
            <div className="sous-section-item">
              <div className="sous-section-title">
                <span className="bullet">•</span>
                {element.data.description}
              </div>
              {element.remarque && (
                <div className="remarque-section-red">
                  <strong>Remarque:</strong> {element.remarque}
                </div>
              )}
            </div>
          )}
          
          {element.type === 'item' && (
            <div className="item-element">
              <div className={`item ${element.data.type_valeur || ''}`}>
                <span className="bullet">-</span>
                {element.data.description}
              </div>
              {element.remarque && (
                <div className="remarque-section-red">
                  <strong>Remarque:</strong> {element.remarque}
                </div>
              )}
            </div>
          )}

          {element.type === 'sousItem' && (
            <div className="sous-item-element">
              <div className={`sous-item ${element.data.type_valeur || ''}`}>
                <span className="indent">--</span>
                {element.data.description}
                {element.unite && <span className="unite"> ................................................................................................................ {element.unite} µm</span>}
              </div>
              {element.remarque && (
                <div className="remarque-section-red">
                  <strong>Remarque:</strong> {element.remarque}
                </div>
              )}
            </div>
          )}
        </div>
      );
    }
    
    // Style pour "Bordereau de prix" (comme dans CreateDevis)
    if (sectionType.includes('Bordereau de prix') || sectionType.includes('Prix')) {
      return (
        <div key={element.id || Math.random()} className="section-element">
          {element.type === 'section' && (
            <div className="section-item">
              <h4>{element.data.description}</h4>
              {element.remarque && (
                <div className="remarque-section-red">
                  <strong>Remarque:</strong> {element.remarque}
                </div>
              )}
              
              {/* Afficher le tableau seulement pour la section, pas pour les sous-sections */}
              <div className="price-table-container">
                <table className="price-table">
                  <thead>
                    <tr>
                      <th>Désignation</th>
                      <th>Unité</th>
                      <th>QT</th>
                      <th>PU DHS HT</th>
                      <th>PT DHS HT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {devis.elements
                      ?.filter(el => el.type === 'sousSection' && el.parentSection?.description?.includes('Bordereau de prix'))
                      .map(sousSection => {
                        // Récupérer les données de prix depuis l'élément ou depuis priceData
                        const priceInfo = sousSection.priceData || {};
                        const qt = priceInfo.qt || sousSection.qt || 0;
                        const pu = priceInfo.pu || sousSection.pu || 0;
                        const total = qt * pu;
                        
                        return (
                          <tr key={sousSection.id || Math.random()}>
                            <td>{sousSection.data?.description || sousSection.description}</td>
                            <td>{sousSection.unite || 'M²'}</td>
                            <td>{qt.toFixed(2)}</td>
                            <td>{pu.toFixed(2)}</td>
                            <td className="price-total">{total.toFixed(2)}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {/* Ne pas afficher les sous-sections individuellement pour le Bordereau de prix */}
        </div>
      );
    }
    
    // Sections spéciales (comme dans CreateDevis)
    if (sectionType.includes('Délai de réalisation') || sectionType.includes('Conditions de paiement') || sectionType.includes("Validité de l'offre")) {
      return (
        <div key={element.id || Math.random()} className="section-element special-section">
          {element.type === 'section' && (
            <div className="section-item">
              <h4>{element.data.description}</h4>
              {element.remarque && (
                <div className="remarque-section-red">
                  <strong>Remarque:</strong> {element.remarque}
                </div>
              )}
            </div>
          )}
          {element.type === 'sousSection' && (
            <div className="sous-section-item">
              <div className="sous-section-title-with-value">
                <span className="bullet">•</span>
                <span className="sous-section-text">{element.data.description}</span>
                <span className="sous-section-value">  {element.value || ""}</span>
              </div>
              {element.remarque && (
                <div className="remarque-section-red">
                  <strong>Remarque:</strong> {element.remarque}
                </div>
              )}
            </div>
          )}
        </div>
      );
    }
    
    // Style par défaut pour "Etendue des travaux" et autres (comme dans CreateDevis)
    return (
      <div key={element.id || Math.random()} className="section-element work-scope">
        {element.type === 'section' && (
          <div className="section-item">
            <h4>{element.data.description}</h4>
            {element.remarque && (
              <div className="remarque-section-red">
                <strong>Remarque:</strong> {element.remarque}
              </div>
            )}
          </div>
        )}
        
        {element.type === 'sousSection' && (
          <div className="sous-section-item">
            <div className={`sous-section-title ${element.data.description.includes('À notre charge') || element.data.description.includes('À votre charge') ? 'charge-section' : ''}`}>
              {element.data.description.includes('À notre charge') || element.data.description.includes('À votre charge') ? (
                <span className="charge-title">{element.data.description}</span>
              ) : (
                <>
                  <span className="arrow">➤</span>
                  {element.data.description}
                </>
              )}
            </div>
            {element.remarque && (
              <div className="remarque-section-red">
                <strong>Remarque:</strong> {element.remarque}
              </div>
            )}
          </div>
        )}
        
        {element.type === 'item' && (
          <div className="item-element">
            <div className={`item ${element.data.type_valeur || ''}`}>
              <span className="bullet">●</span>
              {element.data.description}
            </div>
            {element.remarque && (
              <div className="remarque-section-red">
                <strong>Remarque:</strong> {element.remarque}
              </div>
            )}
          </div>
        )}

        {element.type === 'sousItem' && (
          <div className="sous-item-element">
            <div className={`sous-item ${element.data.type_valeur || ''}`}>
              <span className="indent">-</span>
              {element.data.description}
              {element.unite && <span className="unite"> ................................................................................................................ {element.unite} µm</span>}
            </div>
            {element.remarque && (
              <div className="remarque-section-red">
                <strong>Remarque:</strong> {element.remarque}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // Vérifier si elements existe et est un tableau
  const elements = Array.isArray(devis.elements) ? devis.elements : [];

  return (
    <div className="create-devis-container">
      <div className="preview-header">
        <h2>Aperçu du devis {devis.reference}</h2>
        <div className="preview-actions">
          <div className="dropdown-menu">
            <button 
              className="menu-trigger"
              onClick={(e) => {
                e.stopPropagation();
                setIsMenuOpen(!isMenuOpen);
              }}
            >
              Open Menu
            </button>
            <div className={`menu-content ${isMenuOpen ? 'show' : ''}`}>
              <button style={{background: "none", border: "none", cursor: "pointer", width: "100%", textAlign: "left", padding: "8px", display: "flex", alignItems: "center", gap: "8px"}} onClick={() => onGeneratePDF && onGeneratePDF(devis.id)}>
                <FilePdf size={15} color="#212121" weight="duotone" />
                Générer PDF
              </button>
              <button style={{background: "none", border: "none", cursor: "pointer", width: "100%", textAlign: "left", padding: "8px", display: "flex", alignItems: "center", gap: "8px"}} onClick={() => onGenerateWord && onGenerateWord(devis.id)}>
                <FileDoc size={15} color="#212121" weight="duotone" />
                Générer Word
              </button>
              <button style={{background: "none", border: "none", cursor: "pointer", width: "100%", textAlign: "left", padding: "8px", display: "flex", alignItems: "center", gap: "8px"}} onClick={() => onEdit && onEdit(devis.id)}>
                <PencilSimple size={15} color="#212121" weight="duotone" />
                Modifier
              </button>
              
              <button style={{background: "none", border: "none", cursor: "pointer", width: "100%", textAlign: "left", padding: "8px", display: "flex", alignItems: "center", gap: "8px"}} onClick={() => onClose()}>
                <ArrowUUpLeft size={15} color="#0d0c0c" weight="duotone" />
                Retour à la liste
              </button>
              <button style={{background: "none", border: "none", cursor: "pointer", width: "100%", textAlign: "left", padding: "8px", display: "flex", alignItems: "center", gap: "8px", color: "#dc3545"}} onClick={() => onDelete && onDelete(devis.id)}>
                <Trash size={15} color="#dc3545" weight="duotone" />
                Supprimer
              </button>
            </div>
          </div>
        </div>
      </div>
      
      {/* Aperçu du document (inspiré de CreateDevis) */}
      <div className="preview-document">
        <div className="document-layout">
          <div className="main-table">
            <table className="client-info">
              <tbody>
                <tr>
                  <td>Date</td>
                  <td>{new Date(devis.date).toLocaleDateString()}</td>
                  <td className="offre" rowSpan="1" colSpan="2">OFFRE DE PRIX</td>
                </tr>
                <tr>
                  <td>Nombre de pages (celle-ci comprise)</td>
                  <td>{devis.nombrePages || "1"}</td>
                  <td rowSpan="1"><span className="gr">N/Réf.</span></td>
                  <td rowSpan="1" className="p1">{devis.reference}</td>
                </tr>
                <tr>
                  <td>Destinataire</td>
                  <td>{devis.destinataire || devis.contact || ""}</td>
                </tr>
                <tr>
                  <td>Société</td>
                  <td>{devis.societe || devis.nom_entreprise || ""}</td>
                </tr>
                <tr>
                  <td>Tél</td>
                  <td>{devis.telephone || ""}</td>
                </tr>
                <tr>
                  <td>V/Réf.</td>
                  <td>{devis.vRef || ""}</td>
                </tr>
                <tr>
                  <td>Objet</td>
                  <td colSpan="3">{devis.objet || ""}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="salutation">
          <p>Monsieur,</p>
          <p>Suite à votre demande, nous vous communiquons ci-après nos meilleures conditions pour la réalisation des prestations citées en objet.</p>
        </div>

        {/* Contenu des sections */}
        <div className="sections-content">
          {elements.length > 0 ? (
            elements.map((element, idx) => {
              // Ne pas afficher les sous-sections du "Bordereau de prix" individuellement
              if (element.type === 'sousSection' && element.parentSection?.description?.includes('Bordereau de prix')) {
                return null;
              }
              return renderSectionContent(element);
            }).filter(Boolean) // Filtrer les éléments null
          ) : (
            <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
              <p>Aucun élément trouvé dans ce devis.</p>
            </div>
          )}
        </div>

        {/* Note de fin */}
        <div className="closing-note">
          <p>Nous restons à votre entière disposition pour tout renseignement complémentaire et vous prions d'agréer, Monsieur, nos meilleures salutations.</p>
        </div>
      </div>


    </div>
  );
}

export default DevisPreview;